import React from 'react';
import { Nav } from './components/Nav';
import { Hero } from './components/Hero';
import { BottleStrip } from './components/BottleStrip';
import { Problem } from './components/Problem';
import { WhyCycleBox } from './components/WhyCycleBox';
import { HowItWorks } from './components/HowItWorks';
import { CircularModel } from './components/CircularModel';
import { BehindTheScenes } from './components/BehindTheScenes';
import { RFIDTracking } from './components/RFIDTracking';
import { Technology } from './components/Technology';
import { Impact } from './components/Impact';
import { Personas } from './components/Personas';
import { Industries } from './components/Industries';
import { Pricing } from './components/Pricing';
import { Quote } from './components/Quote';
import { CTA } from './components/CTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-surface selection:bg-leaf selection:text-white" data-id="element-0">
      <Nav data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <BottleStrip data-id="element-4" />
        <Problem data-id="element-5" />
        <WhyCycleBox data-id="element-6" />
        <HowItWorks data-id="element-7" />
        <CircularModel data-id="element-8" />
        <BehindTheScenes data-id="element-9" />
        <RFIDTracking data-id="element-10" />
        <Technology data-id="element-11" />
        <Impact data-id="element-12" />
        <Personas data-id="element-13" />
        <Industries data-id="element-14" />
        <Pricing data-id="element-15" />
        <Quote data-id="element-16" />
        <CTA data-id="element-17" />
      </main>
      <Footer data-id="element-18" />
    </div>;
}